import { gql, useMutation } from '@apollo/client';
import { DeleteUnifiedFieldInput, Mutation } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';
import { LIST_UNIFIED_FIELDS_GQL } from './useFetchUnifiedFields';

export const DELETE_UNIFIED_FIELD = gql`
  mutation deleteUnifiedField($tenantID: ID!, $userID: ID!, $key: String!) {
    deleteUnifiedField(
      request: { tenantID: $tenantID, userID: $userID, key: $key }
    ) {
      success
    }
  }
`;

export const useDeleteUnifiedField = () => {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();
  const [deleteUnifiedField, { loading }] = useMutation<
    Mutation,
    DeleteUnifiedFieldInput
  >(DELETE_UNIFIED_FIELD);

  const deleteMetadataKey = useCallback(
    async (key: string) => {
      await deleteUnifiedField({
        variables: {
          key: key,
          tenantID: tenantID,
          userID: userID,
        },
        refetchQueries: [LIST_UNIFIED_FIELDS_GQL],
      });
    },
    [deleteUnifiedField, tenantID, userID],
  );

  return { deleteMetadataKey, loading };
};
